import EqualHeightElementCollection from "parent/src/js/base/Controllers/EqualHeightElementCollection";
import Waypoint from "parent/src/js/base/Controllers/Waypoint";

class Cards extends EqualHeightElementCollection {
	getSelector() {
		return ".card.equal-height";
	}

	getComponents() {
		const selector = this.getSelector();
		return [
			document.querySelectorAll(selector + " .card-illustration"),
			document.querySelectorAll(selector + " .card-title"),
			document.querySelectorAll(selector + " .card-text")
		];
	}

	afterMatchHeight() {
		super.afterMatchHeight();

		/**
		 * @type {[HTMLElement[]]}
		 */
		const elements = [];
		/**
		 * @type {NodeListOf<HTMLElement>}
		 */
		const selection = document.querySelectorAll(`${this.selector}.${Waypoint.InViewClass}[data-line-index]:not(.animated)`);


		selection.forEach((item, index) => {
			if (this.delayedElementIds.indexOf(item.id) === -1) {
				this.delayedElementIds.push(item.id);

				const lineIndex = parseInt(item.dataset.lineIndex);
				if (!elements[lineIndex]) {
					elements[lineIndex] = [];
				}
				elements[lineIndex].push(item);
			}
		});

		elements.forEach(line => {
			let delay = 0;
			line.forEach(item => {
				window.setTimeout(() => {
					item.classList.add("animated");
				}, delay);
				delay += 150;
			});
		});
	}
}

export default Cards;
